module.exports = __webpack_public_path__ + "img/5_78.b78250cc.png";